import React, { useEffect, useState } from "react";
import { useStore } from "../../Components/StateProvider"; // Re-added as per user's latest selection
import { getlocal } from "../../functions/localstorage";
import { ErrorAlert, GetRecords, SuccessAlert, URLPRIFIX, baseurl, getList, saveRecord } from "../../functions/api";
// Re-added as per user's latest selection

// Import React Icons for a modern look
import {
  FaFolder,
  FaBalanceScale, // Equivalent to Scale
  FaShieldAlt, // Equivalent to Shield
  FaClipboardList,
  FaUsers,
  FaCalendarCheck,
  FaDollarSign,
  FaRegChartBar, // Equivalent to Activity, a more general chart icon
  FaCheckCircle,
  FaHourglassHalf, // Equivalent to Hourglass
  FaArrowRight,
  FaRegDotCircle, // Equivalent to CircleDot
} from "react-icons/fa"; // Using Font Awesome icons from react-icons
import { TbHammer } from "react-icons/tb";
import axios from "axios";
import Dropdown from "../../Components/Fields/Dropdown";
import FileInput from "../../Components/Fields/FileInput";
import Attachement from "../../Components/Fields/Attachement";
import { Input } from "@mui/material";

const AssignTaskModal = ({ isOpen, onClose, onSubmit, assignedToUser }) => {
  const [title, setTitle] = useState('');
  const [projectType, setProjectType] = useState('');
  const [projectList, setProjectList] = useState([]);
  const [projectName, setProjectName] = useState('');
  const [docfield, setDocField] = useState(false);
  const [documentList, setDocumentList] = useState([]);
  const [documentName, setDocumentName] = useState('');
  const [priority, setPriority] = useState('Medium');
  const [dueDate, setDueDate] = useState('');
  const [description, setDescription] = useState('');
  const [attachments, setAttachments] = useState([]); // Support multiple

  const [sendNotification, setSendNotification] = useState(false);
  const store = useStore();
  const projectTypes = [
    { label: 'Non-Litigation', value: 11 },
    { label: 'Litigation', value: 12 },
    { label: 'Trademark', value: 13 },
    // { label: 'Advisory', value: 14 },
  ];
  const priorities = ['High', 'Medium', 'Low'];
  useEffect(() => {
    if (projectType) {
      GetProjectList();
    }
  }, [projectType]);
  useEffect(() => {
    if (projectName) {
      getDocumentList();
    }
  }, [projectName]);
  const handleSubmit = (e) => {
    e.preventDefault();
    const newTaskDetails = {
      title,
      assignedToUser,
      projectName,
      projectType,
      documentName,
      priority,
      dueDate,
      description,
      attachments: (store.getvalue("attachmenturl") || []).filter(Boolean),
      // attachments,
      sendNotification
    };
    onSubmit(newTaskDetails);
    onClose();
  };
  // const handleAttachmentChange = (e) => {
  //   const newFiles = Array.from(e.target.files);
  //   setAttachments(prev => [...prev, ...newFiles]);
  // };

  // const removeAttachment = (index) => {
  //   setAttachments(prev => prev.filter((_, i) => i !== index));
  // };


  if (!isOpen) return null;

  async function GetProjectList(client = {}) {
    console.log("GetProjectList client", client);

    await getList({
      listUrl: `/project/getprojectlist/${projectType}`,
      sort: "asc",
      count: 10000,
    }).then((projects) => {
      if (projects.success) {
        projects = projects?.data?.list || [];
        projects = projects.map((project) => ({
          ...project,
          value: project.id,
          label: project.projectName,
        }));
        // console.log("PRO:", projects);
        setProjectList(projects)
        setProjectName("")
        setDocumentName("")
      }
    });
  }
  async function getDocumentList() {
    await getList({
      listUrl: `/tasks/getprojectstasklist/${projectType}`,
      field: "project_id",
      search: projectName,
      count: 10000,
    }).then((task) => {
      if (task.success) {
        task = task?.data?.list || [];
        task = task.map((taskeach) => ({
          ...taskeach,
          value: taskeach.id,
          label: taskeach.task_title,
        }));
        setDocumentList(task)
        setDocField(task.length > 0);
        console.log("DOCUMENT", task);

      }
    });
  }
  // function projectNameChange(project_id) {
  //   if (project_id != "") {
  //     // GetRecords("/project/getproject/" + project_id + projectType).then(
  //     //   (project) => {
  //     //     if (project.success) {
  //     //       project = project?.record || {};
  //     //       console.log("projectNameChange", project);
  //     //       if (project.parent.category_id == 1) {
  //     //         store.setprops("form_id", { mandatory: true, readonly: true });
  //     //       } else {
  //     //         store.setprops("form_id", { hidden: true });
  //     //         store.setvalue("form_id", "0");
  //     //         console.log("form id check .........", store);
  //     //       }
  //     //       store.setvalue("contact_id", project.parent.contact_id);
  //     //       // GetArtistList(project.parent.contact_id, project.parent.film_id);
  //     //       // getDocumentList(project.parent.id);
  //     //     }
  //     //   }
  //     // );
  //   } else {
  //     store.setprops("form_id", { hidden: true });
  //   }
  // }
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
      <div
        className="rounded-xl shadow-2xl w-full"
        style={{
          maxWidth: '500px',
          maxHeight: '98vh',
          backgroundColor: '#FFFFFF',
          overflowY: 'auto',
          padding: '24px'
        }}
      >
        <h2 className="text-xl font-bold mb-6 text-center" style={{ color: '#111827' }}>
          Assign New Task to{" "}
          {assignedToUser?.name
            ? assignedToUser.name.charAt(0).toUpperCase() + assignedToUser.name.slice(1)
            : ""}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex gap-4">
            <div>
            <label htmlFor="title" className="block text-sm font-medium mb-1" style={{ color: '#374151' }}>
              Task Title
            </label>
            <input
              id="subtaskTitle"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full p-2 rounded-md border resize-y"
              style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
              required
            />
          </div>
            <div className="w-1/2">
              <label htmlFor="projectType" className="block text-sm font-medium mb-1" style={{ color: '#374151' }}>
                Project Type
              </label>
              <select
                id="projectType"
                value={projectType}
                onChange={(e) => setProjectType((e.target.value))}
                className="w-full text-sm p-2 rounded-md border"
                style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
                required>
                <option value="">Select Type</option>
                {projectTypes.map((type) => (<option key={type.value} value={type.value}>{type.label}</option>))}
              </select>

              {/* <select
                id="projectType"
                value={projectType}
                onChange={(e) => setProjectType(e.target.value)}
                className="w-full text-sm p-2 rounded-md border"
                style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
                required
              >
                <option value="">Select Type</option>
                {projectTypes.map(type => <option key={type} value={type}>{type}</option>)}
              </select> */}
            </div>
            <div className="w-1/2">
              <label htmlFor="projectName" className="block text-sm font-medium mb-1" style={{ color: '#374151' }}>
                Project Name
              </label>
              {/* <Dropdown
                className="w-full text-sm p-2 rounded-md border"
                style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
                required
                name="project_id"
                list={store.getprops("projectName_list") || []}
                onchange={projectNameChange}
              /> */}
              <select
                id="projectName"
                value={projectName}
                onChange={(e) => { setDocumentName(""); setProjectName(e.target.value) }}
                className="w-full text-sm p-2 rounded-md border"
                style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
                required
              >
                <option value="">Select Project</option>
                {projectList.map(name => <option key={name.value} value={name.value}>{name.label}</option>)}
              </select>
            </div>
          </div>

          {/* Document Name */}

          <div className="flex gap-4">
            {docfield && (
              <div className="w-1/2">
                <label htmlFor="documentName" className="block text-sm font-medium mb-1" style={{ color: '#374151' }}>
                  Document Name
                </label>
                <select
                  id="documentName"
                  value={documentName}
                  onChange={(e) => setDocumentName(e.target.value)}
                  className="w-full text-sm p-2 rounded-md border"
                  style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
                  required
                >
                  <option value="">Select Document</option>
                  {documentList.map(name => <option key={name.value} value={name.value}>{name.label}</option>)}
                </select>

              </div>
            )}
            {/* Priority */}
            <div className="w-1/2">
              <label htmlFor="priority" className="block text-sm font-medium mb-1" style={{ color: '#374151' }}>
                Priority
              </label>
              <select
                id="priority"
                value={priority}
                onChange={(e) => setPriority(e.target.value)}
                className="w-full text-sm p-2 rounded-md border"
                style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
              >
                {priorities.map(prio => <option key={prio} value={prio}>{prio}</option>)}
              </select>
            </div>
          </div>
          <div className="flex gap-4">
            {/* Due Date */}
            <div className="w-1/2">
              <label htmlFor="dueDate" className="block text-sm font-medium mb-1" style={{ color: '#374151' }}>
                Due Date
              </label>
              <input
                type="date"
                id="dueDate"
                value={dueDate}
                onChange={(e) => setDueDate(e.target.value)}
                className="w-full text-sm p-2 rounded-md border"
                style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
                required
              />
            </div>
            <div className="w-1/2 flex items-center mt-1">
              <input
                type="checkbox"
                id="sendNotification"
                checked={sendNotification}
                onChange={(e) => setSendNotification(e.target.checked)}
                className="mr-2"
              />
              <label htmlFor="sendNotification" className="text-sm font-medium" style={{ color: '#374151' }}>
                Send Notification
              </label>
            </div>

          </div>
          <div>
            <label htmlFor="attachment" className="block text-sm font-medium mb-1" style={{ color: '#374151' }}>
              Attachments
            </label>
            <div className="grid grid-cols-5">
              {store.getvalue("attachmenturl")?.length > 0 ? (
                store.getvalue("attachmenturl").map((item, index) => {
                  // console.log("test 223", item);
                  return (
                    <div className="col-span-1 flex border-r pr-6 w-full  items-center">
                      <Attachement name={"attachmenturl"} fileurl={item} />
                      <button
                        className="hover:bg-tertiary p-1 h-fit w-fit rounded-full"
                        onClick={() => {
                          let arr = [];
                          store
                            .getvalue("attachmenturl")
                            .map((attachitem, attachindex) => {
                              if (attachindex !== index) {
                                arr.push(attachitem);
                              }
                            });
                          store.setvalue("attachmenturl", arr);
                        }}
                      >
                        X
                      </button>
                    </div>
                  );
                })
              ) : (
                <>No Data</>
              )}
              <FileInput
                prefix={"TASK"}

                onchange={(file) => {
                  let attachmenturl = store.getvalue("attachmenturl") || [];
                  attachmenturl.push(file);
                  store.setvalue("attachmenturl", attachmenturl);
                }}
              />
            </div>
            {/* <input
              type="file"
              id="attachment"
              multiple
              onChange={handleAttachmentChange}
              className="w-full text-sm p-2 rounded-md border mb-2"
              style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
            /> */}
            {/* Attachment list with remove */}
            {/* <ul className="space-y-1">
              {attachments.map((file, index) => (
                <li key={index} className="flex items-center justify-between text-sm bg-gray-100 rounded px-2 py-1">
                  <span className="truncate">{file.name}</span>
                  <button
                    type="button"
                    onClick={() => removeAttachment(index)}
                    className="text-red-500 hover:text-red-700"
                    title="Remove"
                  >
                    ❌
                  </button>
                </li>
              ))}
            </ul> */}
          </div>

          {/* Description */}
          <div>
            <label htmlFor="description" className="block text-sm font-medium mb-1" style={{ color: '#374151' }}>
              Description
            </label>
            <textarea
              id="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows="3"
              className="w-full p-2 rounded-md border resize-y"
              style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB', color: '#1F2937' }}
              required
            ></textarea>
          </div>
          

          {/* Buttons */}
          <div className="flex justify-end space-x-3 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-5 py-2 rounded-md font-semibold transition-colors duration-200"
              style={{ backgroundColor: '#E5E7EB', color: '#374151' }}
            >
              Close
            </button>
            <button
              type="submit"
              className="px-5 py-2 rounded-md font-semibold transition-colors duration-200"
              style={{ backgroundColor: '#2563EB', color: '#FFFFFF' }}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};


// Helper component for individual dashboard cards
const DashboardCard = ({ title, value, subtitle, icon: Icon, link, children, className = "" }) => (
  <div className={`bg-white rounded-2xl border border-slate-100 shadow-md p-6 flex flex-col justify-between transition-all duration-300 hover:shadow-lg hover:scale-[1.01] transform ${className}`} style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.01)' }}>
    <div>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          {Icon && <Icon className="text-[#4F46E5] w-6 h-6" />}
          <h3 className="text-sm font-black uppercase tracking-wider text-slate-500" style={{ fontFamily: 'Inter, sans-serif' }}>{title}</h3>
        </div>
      </div>
      {value !== undefined && value !== null && (
        <p className="text-4xl font-extrabold tracking-tight mb-2 text-slate-800">{value}</p>
      )}

      {subtitle && <p className="text-xs font-normal text-slate-400 mb-3">{subtitle}</p>}
      {children}
    </div>
    {link && (
      <button
        onClick={link}
        className="mt-5 font-bold text-xs self-end flex items-center text-[#4F46E5] hover:text-indigo-800 transition-colors focus:outline-none bg-transparent border-0 cursor-pointer"
      >
        View All <FaArrowRight className="ml-1 w-3 h-3" />
      </button>
    )}
  </div>
);

// Main Dashboard Component
const DashboardNew = () => {
  const [loggedInUser, setLoggedInUser] = useState({
    username: 'Admin User', // Default mock user
    initials: 'AU' // Default initials
  });
  const user = getlocal("system")?.user || {};

  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
  const [selectedUserForAssignment, setSelectedUserForAssignment] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [userRole, setuserRole] = useState('');


  // Re-added useStore and init as per user's latest selection
  const store = useStore();
  const init = {
    assignTask: [],
    DocumentList: [],
    Duedatelistdoc: [],
    Schedulecal: "",
  };

  // Simulate initial setup (like store.setmodule, store.setheader, store.stopLoading)
  useEffect(() => {
    store.setmodule("dashboard", init);
    store.setheader("Hello, " + getlocal("system")?.user?.name);
    store.stopLoading();
    setLoggedInUser({ username: 'Alice Smith', initials: 'AS' });
  }, []);

  useEffect(() => {
    const fetchDashboardData = () => {
      let token = getlocal("system").token;

      let role_id = getlocal("system")?.user?.role;
      console.log("check role***", role_id);
      let url = "";
      url += "user_id=" + getlocal("system")?.user?.id;
      setuserRole(role_id);
      axios.get(`${baseurl}/api/Non_litigation_Dashboard/non-litigation-dashboard?${url}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then((res) => {
          setDashboardData(res?.data);
          console.log("response for dashboard", res);
        })
        .catch((err) => {
          console.error("Dashboard error:", err);
        })
        .finally(() => {
          setLoading(false);
        });
    };

    fetchDashboardData();
  }, []);

  const handleAssignTaskClick = (user) => {
    setSelectedUserForAssignment(user);
    setIsAssignModalOpen(true);
  };

  if (loading || !dashboardData) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#f8fafc]">
        <div className="text-lg font-bold text-[#4F46E5]">Loading dashboard data...</div>
      </div>
    );
  }

  const filteredUsers = dashboardData?.userWorkload.filter(user =>
    user.name.toLowerCase().includes(searchQuery.toLowerCase())
  ) || [];

  const handleTaskSubmit = (taskDetails) => {
    console.log("New Task Submitted:", taskDetails);
    const payload = {
      type: taskDetails.projectType,
      project_id: taskDetails.projectName,
      status: "Draft",
      subtask_title: taskDetails.title,
      assigned_to: taskDetails.assignedToUser.id,
      attachmenturl: taskDetails.attachments,
      dueDate: new Date(taskDetails.dueDate).toISOString(),
      priority: taskDetails.priority,
      description: taskDetails.description,
      createdBy: store.getuser().id,
      createdDate: new Date().toISOString(),
      ...(taskDetails.documentName && { task_id: taskDetails.documentName }),

    };
    const setrecord = `/subtask/addsubtasks/${payload.type}`;
    saveRecord(setrecord, payload)
      .then((res) => {
        if (res.success) {
          console.log("Response of saveRecord:", res);
          SuccessAlert("Task Assigned Successfully");
        } else {
          console.error("Error response:", res);
          ErrorAlert("Unable to save the Task Assigned as unchoose. Please Choose assigned to Field");
        }
      })
    setDashboardData(prevData => {
      const updatedUserWorkload = prevData.userWorkload.map(user => {
        if (user.id === taskDetails.assignedToUser.id) {
          return {
            ...user,
            tasks: user.tasks + 1,
            pendingTasks: user.pendingTasks + 1,
          };
        }
        return user;
      });

      const newActivity = {
        id: `act${Date.now()}`,
        text: `New '${taskDetails.priority}' priority task assigned to ${taskDetails.assignedToUser.name}: '${taskDetails.documentName}' for '${taskDetails.projectName}'. Due: ${taskDetails.dueDate}`,
        time: 'Just now',
      };

      return {
        ...prevData,
        userWorkload: updatedUserWorkload,
        recentActivity: [newActivity, ...prevData.recentActivity].slice(0, 5),
      };
    });
  };

  const userWithLeastTasks = dashboardData.userWorkload.reduce((minUser, currentUser) => {
    return currentUser.tasks < minUser.tasks ? currentUser : minUser;
  }, dashboardData.userWorkload[0]);

  const myAssignedTasksTotal = dashboardData.tasks.assignedToMe.total;
  const myAssignedTasksCompleted = dashboardData.tasks.assignedToMe.statusCounts.approved;
  const myAssignedTasksPending = dashboardData.tasks.assignedToMe.statusCounts.onHold;
  const myAssignedTaskType = dashboardData.tasks.assignedToMe.task_type;

  return (
    <div className="min-h-screen bg-[#f8fafc] p-6 sm:p-8 font-inter" style={{ paddingBottom: '120px' }}>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">
        {userRole == 1 &&
          <DashboardCard
            title="Non-Litigation Projects"
            value={dashboardData.projects.nonLitigation.totalProjects}
            icon={FaBalanceScale}
            link={() => store.navTo(`/${URLPRIFIX}/projects/list`)}
          >
            <div className="text-xs space-y-1 font-normal text-slate-500">
              <p><span className="font-semibold text-emerald-600">{dashboardData.projects.nonLitigation.documentsCompleted}</span> Documents Completed</p>
              <p><span className="font-semibold text-[#4F46E5]">{dashboardData.projects.nonLitigation.taskDraft}</span> Tasks in Draft</p>
              <p><span className="font-semibold text-amber-600">{dashboardData.projects.nonLitigation.tasksPending}</span> Tasks Inprogress</p>
              <p><span className="font-semibold text-emerald-600">{dashboardData.projects.nonLitigation.tasksCompleted}</span> Tasks Completed</p>
            </div>
          </DashboardCard>
        }

        {userRole == 1 &&
          <DashboardCard
            title="Litigation Cases"
            value={dashboardData.projects.litigation.totalProjects}
            icon={TbHammer}
            link={() => store.navTo(`/${URLPRIFIX}/litigation/projects/list`)}
          >
            <div className="text-xs space-y-1 font-normal text-slate-500">
              <p><span className="font-semibold text-emerald-600">{dashboardData.projects.litigation.statusCounts.approved}</span> Approved/Won Cases</p>
              <p><span className="font-semibold text-[#4F46E5]">{dashboardData.projects.litigation.statusCounts.open}</span> Open Cases</p>
              <p><span className="font-semibold text-rose-600">{dashboardData.projects.litigation.statusCounts.onHold}</span> Cases On Hold</p>
            </div>
          </DashboardCard>
        }

        {userRole == 1 &&
          <DashboardCard
            title="Trademark Registrations"
            value={dashboardData.projects.trademark.totalProjects}
            icon={FaShieldAlt}
            link={() => store.navTo(`/${URLPRIFIX}/trademark/projects/list`)}
          >
            <div className="text-xs space-y-1 font-normal text-slate-500">
              <p><span className="font-semibold text-emerald-600">{dashboardData.projects.trademark.statusCounts.approved}</span> Approved Registrations</p>
              <p><span className="font-semibold text-[#4F46E5]">{dashboardData.projects.trademark.statusCounts.open}</span> Filed Applications</p>
              <p><span className="font-semibold text-rose-600">{dashboardData.projects.trademark.statusCounts.rejected}</span> Rejected Applications</p>
            </div>
          </DashboardCard>
        }

        <DashboardCard
          title="My Assigned Tasks"
          value={myAssignedTasksTotal}
          subtitle="Tasks assigned to you"
          icon={FaClipboardList}
          link={() => {
            if (myAssignedTaskType === 11) {
              store.removemodule("nonlitigation_task");
              store.navTo(`/demo/tasks/list/${user.id}`);
            } else if (myAssignedTaskType === 12) {
              store.removemodule("litigation_task");
              store.navTo(`/demo/litigation/tasks/list/${user.id}`);
            } else {
              store.removemodule("trademark_task");
              store.navTo(`/demo/trademark/tasks/list/${user.id}`);
            }
          }}
        >
          <div className="flex items-center justify-between text-xs font-normal text-slate-500">
            <p className="flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span> Completed: <span className="font-semibold text-slate-700 ml-0.5">{myAssignedTasksCompleted}</span></p>
            <p className="flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse"></span> Pending: <span className="font-semibold text-slate-700 ml-0.5">{myAssignedTasksPending}</span></p>
          </div>
          <div className="h-2 rounded-full mt-4 overflow-hidden bg-slate-100 border border-slate-200/50">
            <div
              className="h-full rounded-full bg-[#4F46E5]"
              style={{ width: `${(myAssignedTasksCompleted / myAssignedTasksTotal) * 100 || 0}%` }}
            ></div>
          </div>
        </DashboardCard>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <DashboardCard
          title="Upcoming Deadlines"
          subtitle="Critical tasks requiring immediate attention"
          icon={FaCalendarCheck}
        >
          <div className="max-h-[410px] overflow-y-auto custom-scrollbar pr-2 mt-4">
            <ul className="space-y-3">
              {(() => {
                const deadlines = userRole == 1 
                  ? (dashboardData.upcomingDeadlines || []) 
                  : (dashboardData.upcomingDeadlines || []).filter(
                      d => d.assignedTo?.toLowerCase() === user.name?.toLowerCase()
                    );
                return deadlines.length > 0 ? (
                  deadlines.map(deadline => (
                    <li key={deadline.id} className="flex items-center justify-between p-3.5 rounded-2xl border border-slate-100 bg-[#fcfcfe] shadow-sm">
                      <div>
                        <p className="text-xs font-semibold text-slate-700">{deadline.title}</p>
                        <p className="text-[11px] font-normal text-slate-400 mt-0.5">
                          <span className="text-[#4F46E5] font-medium">{deadline.project}</span> | Due: {new Date(deadline.date).toLocaleDateString('en-IN', { month: 'short', day: 'numeric', year: 'numeric' })}
                        </p>
                      </div>
                      <div className="flex items-center text-xs font-semibold text-slate-500">
                        <FaUsers className="w-4 h-4 mr-1 text-[#4F46E5]" /> {deadline.assignedTo}
                      </div>
                    </li>
                  ))
                ) : (
                  <p className="text-xs font-normal text-slate-400">No upcoming deadlines.</p>
                );
              })()}
            </ul>
          </div>
        </DashboardCard>

        {userRole == 1 &&
          <DashboardCard
            title={
              <div className="flex items-center justify-between w-full">
                <div className="flex items-center gap-2">
                  <FaUsers className="text-[#4F46E5]" />
                  <h2 className="text-sm font-black uppercase tracking-wider text-slate-500">Users Workload Distribution</h2>
                </div>
                <input
                  type="text"
                  placeholder="Search users..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="px-3 py-1.5 text-xs rounded-xl border border-slate-200 focus:outline-none transition-all duration-300 w-36"
                  style={{ backgroundColor: '#ffffff', color: '#1F2937' }}
                />
              </div>
            }
            subtitle={
              <div className="flex flex-col gap-2 mt-1">
                <p className="text-xs font-normal text-slate-400">Identify resource capacities and metrics</p>
                <div className="flex flex-wrap gap-3 items-center">
                  <div className="flex items-center gap-1">
                    <span className="w-2.5 h-2.5 bg-[#EFF6FF] rounded-full border border-[#BFDBFE]"></span>
                    <span className="text-[10px] text-slate-500 font-semibold">Total</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <span className="w-2.5 h-2.5 bg-[#d6eaf8] rounded-full border border-[#aed6f1]"></span>
                    <span className="text-[10px] text-slate-500 font-semibold">Draft</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <span className="w-2.5 h-2.5 bg-[#f9e79f] rounded-full border border-[#f7dc6f]"></span>
                    <span className="text-[10px] text-slate-500 font-semibold">In Progress</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <span className="w-2.5 h-2.5 bg-[#ffcccb] rounded-full border border-[#f5b7b1]"></span>
                    <span className="text-[10px] text-slate-500 font-semibold">Overdue</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <span className="w-2.5 h-2.5 bg-[#F3E8FF] rounded-full border border-[#C084FC]"></span>
                    <span className="text-[10px] text-slate-500 font-semibold">Badges</span>
                  </div>
                </div>
              </div>
            }
            className="overflow-hidden"
          >
            <div className="max-h-[410px] overflow-y-auto custom-scrollbar pr-2 mt-4">
              <ul className="space-y-3">
                {filteredUsers.length > 0 ? (
                  filteredUsers.map(user => (
                    <li key={user.id} className="flex items-center justify-between p-3.5 rounded-2xl border border-slate-100 bg-[#fcfcfe] shadow-sm">
                      <div className="flex items-center">
                        <img src={`https://placehold.co/40x40/e0e7ff/3b82f6?text=${user.initials || 'US'}`} alt={user.name} className="w-8 h-8 rounded-full mr-3 border border-indigo-200" />
                        <span className="text-xs font-semibold text-slate-700">{user.name}</span>
                      </div>
                      <div className="flex items-center gap-1.5">
                        {/* Total */}
                        <span className="px-2 py-0.5 rounded-full text-[10px] font-semibold border"
                          style={{ backgroundColor: '#EFF6FF', color: '#2563EB', borderColor: '#BFDBFE' }}
                          title="Total Tasks">
                          T: {user.tasks || 0}
                        </span>
                        {/* Draft */}
                        <span className="px-2 py-0.5 rounded-full text-[10px] font-semibold border"
                          style={{ backgroundColor: '#d6eaf8', color: '#21618c', borderColor: '#aed6f1' }}
                          title="Draft Tasks">
                          D: {user.draft || 0}
                        </span>
                        {/* In Progress */}
                        <span className="px-2 py-0.5 rounded-full text-[10px] font-semibold border"
                          style={{ backgroundColor: '#f9e79f', color: '#b7950b', borderColor: '#f7dc6f' }}
                          title="In Progress">
                          P: {user.pendingTasks || 0}
                        </span>
                        {/* Overdue */}
                        <span className="px-2 py-0.5 rounded-full text-[10px] font-semibold border"
                          style={{ backgroundColor: '#ffcccb', color: '#cc0000', borderColor: '#f5b7b1' }}
                          title="Overdue Tasks">
                          O: {user.overdue || 0}
                        </span>
                        {/* Badges */}
                        <span className="px-2 py-0.5 rounded-full text-[10px] font-semibold border flex items-center gap-0.5"
                          style={{ backgroundColor: '#1d8d0c', color: '#edeaf3', borderColor: '#0d4115' }}
                          title="Badges">
                          ⭐ {user.badgeCount || 0}
                        </span>

                        <button
                          onClick={() => handleAssignTaskClick(user)}
                          className="px-2.5 py-1 rounded-xl text-[10px] transition-all hover:scale-110 cursor-pointer border-0 bg-[#21618c] text-[#EFF6FF] flex items-center gap-1"
                        >
                          + Assign
                        </button>
                      </div>
                    </li>
                  ))
                ) : (
                  <p className="text-xs font-semibold text-slate-400">No users found matching your search.</p>
                )}
              </ul>
            </div>
          </DashboardCard>
        }

        {userRole == 1 &&
          <DashboardCard
            title="Accounting Summary"
            subtitle="Financial overview for the current period"
            icon={FaDollarSign}
            className="lg:col-span-1"
          >
            <div className="space-y-2 mt-4 text-xs font-normal text-slate-500">
              <p className="flex justify-between items-center text-sm font-semibold text-slate-700">
                Total Invoiced: <span className="text-[#4F46E5] font-bold">
                  {dashboardData.accountingSummary.totalInvoiced.toLocaleString("en-IN", {
                    style: "currency",
                    currency: "INR"
                  })}
                </span>
              </p>
              <p className="flex justify-between items-center">
                Amount Received: <span className="font-semibold text-emerald-600">
                  {dashboardData.accountingSummary.amountReceived.toLocaleString("en-IN", {
                    style: "currency",
                    currency: "INR"
                  })}
                </span>
              </p>
              <p className="flex justify-between items-center">
                Outstanding Balance: <span className="font-semibold text-amber-600">
                  {dashboardData.accountingSummary.outstandingBalance.toLocaleString("en-IN", {
                    style: "currency",
                    currency: "INR"
                  })}
                </span>
              </p>
            </div>
            <div className="mt-6 border-t border-slate-100 pt-4">
              <h4 className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-3">Top Clients</h4>
              <ul className="space-y-2.5 text-xs font-medium text-slate-600">
                {dashboardData.accountingSummary.topClients.map(client => (
                  <li key={client.id} className="flex justify-between items-center">
                    <span>{client.name}</span>
                    <span className="text-[#4F46E5] font-semibold">{client.amount.toLocaleString("en-IN", {
                      style: "currency",
                      currency: "INR"
                    })}</span>
                  </li>
                ))}
              </ul>
            </div>
          </DashboardCard>
        }

        {userRole == 1 &&
          <DashboardCard
            title="Recent Activity"
            subtitle="Latest actions across the platform"
            icon={FaRegChartBar}
            className="lg:col-span-1"
          >
            <ul className="space-y-3 mt-4 max-h-[410px] overflow-y-auto custom-scrollbar pr-2">
              {dashboardData.recentActivity.length > 0 ? (
                dashboardData.recentActivity.map(activity => (
                  <li key={activity.id} className="flex items-start p-3.5 rounded-2xl border border-slate-100 bg-[#fcfcfe] shadow-sm">
                    <FaRegDotCircle className="w-4 h-4 mt-0.5 mr-3 flex-shrink-0 text-indigo-400" />
                    <div>
                      <p className="text-xs font-semibold text-slate-700">{activity.text}</p>
                      <p className="text-[10px] mt-0.5 font-normal text-slate-400">{activity.time}</p>
                    </div>
                  </li>
                ))
              ) : (
                <p className="text-xs font-normal text-slate-400">No recent activity.</p>
              )}
            </ul>
          </DashboardCard>
        }
      </div>

      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }
      `}</style>
      <AssignTaskModal
        isOpen={isAssignModalOpen}
        onClose={() => setIsAssignModalOpen(false)}
        onSubmit={handleTaskSubmit}
        assignedToUser={selectedUserForAssignment}
      />
    </div>
  );
};

export default DashboardNew;
